import React, { createContext, useContext, ReactNode } from 'react';
import { IntlProvider, useIntl, IntlShape } from 'react-intl';

// Define the type for the context, which will hold the `intl` object from `react-intl`
const IntlContext = createContext<IntlShape | null>(null);

// Define the props type for the provider component
interface IntlProviderWithContextProps {
	children: ReactNode;
}

// Create a provider component that provides the `intl` object to the context
export const IntlProviderWithContext: React.FC<IntlProviderWithContextProps> = ({ children }) => {
	const intl = useIntl();
	return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>;
};

// Custom hook to access the `intl` object from the context
export const useIntlContext = (): IntlShape => {
	const context = useContext(IntlContext);
	if (!context) {
		throw new Error('useIntlContext must be used within an IntlProviderWithContext');
	}
	return context;
};
